document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.get-in-touch-form').forEach(function (form) {
    const section = form.closest('.get-in-touch[data-klaviyo-company-id]');
    if (!section) return;

    const submitBtn = form.querySelector('.js-submit-btn');
    const message = form.querySelector('.js-form-message');

    const companyId = (section.dataset.klaviyoCompanyId || '').trim();
    const listId = (section.dataset.klaviyoListId || '').trim();

    const initialButtonHtml = submitBtn ? submitBtn.innerHTML : '';

    const fields = {
      first_name: form.querySelector('input[name="first_name"]'),
      organization: form.querySelector('input[name="organization"]'),
      email: form.querySelector('input[name="email"]')
    };

    // Honeypot: kept out of `fields` so it is never validated or sent to Klaviyo.
    const honeypot = form.querySelector('input[name="website_url"]');

    const namePattern = /^[A-Za-zА-Яа-яЁё\s'-]+$/;
    const companyPattern = /^[A-Za-zА-Яа-яЁё0-9\s&.,'()/-]+$/;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function showMessage(text, type) {
      if (!message) return;
      message.hidden = false;
      message.textContent = text;
      message.classList.remove('is-error', 'is-success');
      message.classList.add(type === 'success' ? 'is-success' : 'is-error');
    }

    function clearMessage() {
      if (!message) return;
      message.hidden = true;
      message.textContent = '';
      message.classList.remove('is-error', 'is-success');
    }

    function markInvalid(input, invalid) {
      if (!input) return;
      invalid ? input.setAttribute('aria-invalid', 'true') : input.removeAttribute('aria-invalid');
    }

    function resetButtonState() {
      if (!submitBtn) return;
      submitBtn.classList.remove('is-success');
      submitBtn.disabled = false;
      submitBtn.innerHTML = initialButtonHtml;
    }

    function setButtonSuccessState() {
      if (!submitBtn) return;

      submitBtn.classList.add('is-success');
      submitBtn.disabled = true;
      submitBtn.innerHTML = `
        <span>Message Sent!</span>
        <img src="/cdn/shop/t/38/assets/done.svg" alt="" aria-hidden="true">
      `;
    }

    function validate() {
      clearMessage();

      const firstName = fields.first_name ? fields.first_name.value.trim() : '';
      const organization = fields.organization ? fields.organization.value.trim() : '';
      const email = fields.email ? fields.email.value.trim() : '';

      const errors = [];

      if (!firstName) {
        markInvalid(fields.first_name, true);
        errors.push('Name: please enter your name.');
      } else if (firstName.length < 2) {
        markInvalid(fields.first_name, true);
        errors.push('Name: please enter at least 2 letters.');
      } else if (!namePattern.test(firstName)) {
        markInvalid(fields.first_name, true);
        errors.push('Name: use letters only. Numbers and special symbols are not allowed.');
      } else {
        markInvalid(fields.first_name, false);
      }

      if (!organization) {
        markInvalid(fields.organization, true);
        errors.push('Company: please enter your company name.');
      } else if (organization.length < 2) {
        markInvalid(fields.organization, true);
        errors.push('Company: please enter at least 2 characters.');
      } else if (!companyPattern.test(organization)) {
        markInvalid(fields.organization, true);
        errors.push('Company: use letters, numbers, spaces, and basic punctuation only.');
      } else {
        markInvalid(fields.organization, false);
      }

      if (!email) {
        markInvalid(fields.email, true);
        errors.push('Email: please enter your email address.');
      } else if (!emailPattern.test(email)) {
        markInvalid(fields.email, true);
        errors.push('Email: please enter a valid email, for example name@company.com.');
      } else {
        markInvalid(fields.email, false);
      }

      if (!companyId) {
        errors.push('Form error: missing Klaviyo company ID.');
      }

      if (!listId) {
        errors.push('Form error: missing Klaviyo list ID.');
      }

      if (errors.length > 0) {
        showMessage(errors.join(' '), 'error');
        return false;
      }

      return true;
    }

    Object.values(fields).forEach(function (input) {
      if (!input) return;

      input.addEventListener('input', function () {
        input.removeAttribute('aria-invalid');

        if (message && message.classList.contains('is-error')) {
          clearMessage();
        }

        if (submitBtn && submitBtn.classList.contains('is-success')) {
          resetButtonState();
        }
      });
    });

    async function submitToKlaviyo(payload) {
      const body = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: payload.email,
                  first_name: payload.first_name,
                  organization: payload.organization
                }
              }
            },
            custom_source: 'get-in-touch-form'
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      };

      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-06-15'
          },
          body: JSON.stringify(body)
        }
      );

      if (!response.ok) {
        let errorText = 'Klaviyo request failed';

        try {
          const errorJson = await response.json();
          if (errorJson?.errors?.length) {
            errorText = errorJson.errors.map((item) => item.detail || item.title).join(' | ');
          }
        } catch (e) {
          try {
            errorText = await response.text();
          } catch (_) {}
        }

        throw new Error(errorText);
      }

      return response;
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      resetButtonState();

      // Bot filled the hidden field: fake a success without calling Klaviyo.
      if (honeypot && honeypot.value.trim() !== '') {
        form.reset();
        setButtonSuccessState();
        return;
      }

      if (!validate()) return;

      const payload = {
        first_name: fields.first_name.value.trim(),
        organization: fields.organization.value.trim(),
        email: fields.email.value.trim()
      };

      clearMessage();

      if (submitBtn) {
        submitBtn.disabled = true;
      }

      try {
        await submitToKlaviyo(payload);
        form.reset();
        setButtonSuccessState();
      } catch (error) {
        console.error('Klaviyo submit error:', error);
        showMessage(error.message || 'Something went wrong. Please try again.', 'error');

        if (submitBtn) {
          submitBtn.disabled = false;
        }
      }
    });
  });
});